import moment from '@/plugins/vue-moment.js';

/**
 * Whether an activity's due time has passed.
 *
 * The API sends due_at as a naive UTC string such as "2026-03-10 17:00:00". It is parsed
 * as UTC here because `new Date()` reads that string as browser-local time (D3).
 *
 * The server closes the two kinds of work at different instants, and this mirrors it (D1):
 * submissions close after the due time (Activity::pastDue), quiz attempts close at it
 * (Activity::isLate). Pass `closesAtDueTime` for quizzes.
 *
 * @param {string|null|undefined} dueAt
 * @param {{ now?: import('moment').Moment, closesAtDueTime?: boolean }} [options]
 * @returns {boolean}
 */
export function isPastDue(dueAt, { now = moment.utc(), closesAtDueTime = false } = {}) {
    if (!dueAt) {
        return false;
    }

    const due = moment.utc(dueAt);

    return closesAtDueTime ? !now.isBefore(due) : now.isAfter(due);
}
